
export default {
  headbar: [
    {
      label: '首页',
      key: 'home',
      path: '/'
    },
    {
      label: '定制旅行',
      key: 'customize',
      path: '/customize'
    },
    {
      label: '智能路书',
      key: 'roadbook',
      path: '/'
    },
    {
      label: '跟团自驾',
      key: 'grouptour',
      path: '/'
    },
    {
      label: '旅行故事',
      key: 'travelstory',
      path: '/'
    },
    {
      label: '关于我们',
      key: 'about',
      path: '/'
    },
  ],
  friendlylink: [
    {
      image: 'https://qishimai-1257428522.file.myqcloud.com/website/new/friendly_link/ctrip.png',
      url: 'https://vacations.ctrip.com/travel/store-detail?productid=29803006&brandid=25443&deptcityid=10&destcityid=39&providerid=54913&shopid=&salemode=R'
    },
    {
      image: 'https://qishimai-1257428522.file.myqcloud.com/website/new/friendly_link/mafengwo.png',
      url: 'http://www.mafengwo.cn/sales/shop/2912'
    },
    {
      image: 'https://qishimai-1257428522.file.myqcloud.com/website/new/friendly_link/flypig.png',
      url: 'https://bjqsmly.fliggy.com/shop/view_shop.htm?spm=181.11197625.4974055.2.3d6f4a0awD6s9V/'
    },
    {
      image: 'https://qishimai-1257428522.file.myqcloud.com/website/new/friendly_link/xiaohongshu.png',
      url: 'https://www.xiaohongshu.com/user/profile/60700dcd000000000101f2a6?xhsshare=CopyLink&appuid=5ce7d88700000000170336ce&apptime=1626550604'
    },
    {
      image: 'https://qishimai-1257428522.file.myqcloud.com/website/new/friendly_link/toutiao.png',
      url: 'https://profile.zjurl.cn/rogue/ugc/profile/?version_code=8.3.3&version_name=80303&user_id=72016223959&media_id=1701354013218820&request_source=1&active_tab=dongtai&device_id=65&app_name=news_article&share_token=787DFA91-1D34-42E4-A062-6D6132302F6C&tt_from=copy_link&utm_source=copy_link&utm_medium=toutiao_ios&utm_campaign=client_share'
    },
    {
      image: 'https://qishimai-1257428522.file.myqcloud.com/website/new/friendly_link/zhihu.png',
      url: 'https://www.zhihu.com/org/qi-shi-mai-lu-xing-51'
    },
    {
      image: 'https://qishimai-1257428522.file.myqcloud.com/website/new/friendly_link/websitephone_bottom_links_douyinchina.png',
      url: 'https://v.douyin.com/RBcJnF1/'
    },
    {
      image: 'https://qishimai-1257428522.file.myqcloud.com/website/new/friendly_link/websitephone_bottom_links_douyinforeign.png',
      url: 'https://v.douyin.com/RBvWhWw/'
    },
    {
      image: 'https://qishimai-1257428522.file.myqcloud.com/website/new/friendly_link/websitephone_bottom_links_kuaishou.png',
      url: 'https://v.kuaishouapp.com/s/Iu0TZ3re'
    },
    {
      image: 'https://qishimai-1257428522.file.myqcloud.com/website/new/friendly_link/weibo.png',
      url: 'https://weibo.com/u/6177513572'
    },
  ]
}


// WEBPACK FOOTER //
// ./src/utils/staticData/commonData.js